import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { editCalendarDateFailed, editCalendarDateSuccessful } from '../actions';
import { OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* editCalendarDate(action) {
  try {
    const pool = action.payload;

    const url = `${BACKEND_URL}/proxy/tariff/v1/calendar-dates/${pool?.id}`;
    const dataResponse = yield makeRequest(url, pool, action, 'PUT', true);
    if (dataResponse.status === OK) {
      yield put(editCalendarDateSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(editCalendarDateFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(editCalendarDateFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
